// extracted by mini-css-extract-plugin
export default {"sentry":"DxH75LYc","title":"Otd0TMvU","subtitle":"sL_g1f8H","link":"zbZuQnEF","btn":"nshlR94H"};